import { Link } from 'react-router-dom';
import { categories } from '@/mocks/articles';

const catImages: Record<string, string> = {
  'asmr-audio': 'https://readdy.ai/api/search-image?query=Soft%20minimalist%20studio%20scene%20with%20a%20vintage%20microphone%20and%20headphones%20on%20a%20wooden%20desk%2C%20warm%20cream%20background%2C%20cozy%20atmosphere%2C%20gentle%20natural%20lighting%2C%20editorial%20photography%20style%2C%20clean%20composition&width=600&height=400&seq=cat-asmr-01&orientation=landscape',
  'immersive-soundscape': 'https://readdy.ai/api/search-image?query=Dreamy%20misty%20forest%20with%20soft%20morning%20fog%20and%20gentle%20sunlight%20rays%2C%20peaceful%20nature%20scene%2C%20warm%20cream%20and%20sage%20green%20tones%2C%20ethereal%20atmosphere%2C%20fine%20art%20landscape%20photography&width=600&height=400&seq=cat-soundscape-01&orientation=landscape',
  'earphone-recommend': 'https://readdy.ai/api/search-image?query=Elegant%20premium%20headphones%20displayed%20on%20a%20minimalist%20marble%20surface%2C%20soft%20warm%20side%20lighting%2C%20cream%20background%2C%20luxurious%20product%20photography%20style%2C%20clean%20sophisticated%20composition&width=600&height=400&seq=cat-earphone-01&orientation=landscape',
  'ersao-tips': 'https://readdy.ai/api/search-image?query=A%20person%20with%20closed%20eyes%20wearing%20headphones%20in%20a%20cozy%20minimalist%20room%2C%20soft%20warm%20sunlight%2C%20peaceful%20meditation%20vibe%2C%20cream%20walls%2C%20wooden%20accents%2C%20editorial%20interior%20photography&width=600&height=400&seq=cat-tips-01&orientation=landscape',
  'sound-healing': 'https://readdy.ai/api/search-image?query=A%20serene%20yoga%20space%20with%20a%20singing%20bowl%20on%20a%20wooden%20floor%2C%20soft%20warm%20candlelight%2C%20cream%20walls%2C%20peaceful%20healing%20atmosphere%2C%20minimalist%20zen%20aesthetic%2C%20fine%20art%20photography&width=600&height=400&seq=cat-healing-01&orientation=landscape',
};

export default function CategoryGrid() {
  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-900 mb-3">
            探索分类
          </h2>
          <p className="text-sm text-foreground-600 max-w-lg mx-auto">
            五大内容板块，全方位满足你的听觉渴望
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group relative rounded-lg overflow-hidden aspect-[4/5] cursor-pointer"
            >
              <img
                src={catImages[cat.slug]}
                alt={cat.name}
                className="absolute inset-0 w-full h-full object-cover group-hover:scale-110 transition-transform duration-600"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent"></div>
              <div className="absolute bottom-0 left-0 right-0 p-4 text-center">
                <div className="w-10 h-10 mx-auto mb-2 flex items-center justify-center rounded-full bg-background-50/20 text-background-50">
                  <i className={`${cat.icon} text-lg`}></i>
                </div>
                <h3 className="text-base font-semibold font-heading text-background-50 mb-1 whitespace-nowrap">
                  {cat.name}
                </h3>
                <p className="text-xs text-background-200/80 line-clamp-2 leading-relaxed">
                  {cat.description}
                </p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}